<template>
    <div class="bg-white my-4 px-6 py-4">
        <div class="flex flex-col w-full">
            <h2 class="text-2xl font-bold mb-5">{{ organisation.name}}</h2>

            <div v-if="!edit">
                <div class="mt-4">
                    <span class="font-bold">Default Lab: </span>
                    <span>{{ organisation.default_lab_name }}</span>
                </div>

                <div class="mt-4">
                    <span class="font-bold">Default Test: </span>
                    <span>{{ organisation?.default_test?.name }}</span>
                </div>

                <div class="mt-4">
                    <span class="font-bold">Available Test: </span>
                    <span>{{ organisation.available_test }}</span>
                </div>

                <div class="mt-4">
                    <h3 class="text-lg font-bold">FBA Labs</h3>
                    <span class="font-bold">Account id: </span>
                    <span>{{ organisation.fba_labs_id }}</span>
                </div>

                <div class="mt-4">
                    <h3 class="text-lg font-bold">Dairygold</h3>
                    <span class="font-bold">Account id: </span>
                    <span>{{ organisation.dairygold_id }}</span>
                </div>

                <div class="mt-4">
                    <h3 class="text-lg font-bold">Southern Scientific</h3>
                    <span class="font-bold">Account id: </span>
                    <span>{{ organisation.southern_scientific_id }}</span>
                </div>

                <div class="mt-4">
                    <h3 class="text-lg font-bold">IAS</h3>
                    <span class="font-bold">Account id: </span>
                    <span>{{ organisation.ias_id }}</span>
                </div>

                <div class="mt-8">
                    <button
                        class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500  disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                        v-on:click="edit = true"
                    >
                        Edit
                    </button>
                </div>
            </div>

            <div v-if="edit">
                <!-- Default Lab -->
                <div class="mt-4">
                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="default_lab">
                            Default Lab:
                        </label>

                        <select
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="default_lab"
                            v-model="form.default_lab"
                        >
                            <option value="">No Lab</option>
                            <option v-for="(lab, key) in labs" :value="key" :key="key">{{ lab }}</option>
                        </select>
                    </div>
                </div>

                <div class="mt-4">
                    <div class="">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="default_lab">
                            Available Tests:
                        </label>

                        <div class="w-full">
                            <Multiselect v-model="form.tests" :options=tests @select="updateAllowTest()" @deselect="updateAllowTest()" mode="tags"/>
                        </div>
                    </div>
                </div>


                <div class="mt-4">
                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="default_lab">
                            Default Test:
                        </label>

                        <select
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="default_lab"
                            v-model="form.default_test"
                        >
                            <option value="">Select Test</option>
                            <option v-for="(test, key) in allowTests" :value="key" :key="key">{{ test }}</option>
                        </select>
                    </div>
                </div>


                <!-- FBA Labs -->
                <div class="mt-4">
                    <h3 class="text-lg font-bold">FBA Labs</h3>

                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="fba_labs_id">
                            Account ID:
                        </label>

                        <input
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="fba_labs_id" type="text" v-model="form.fba_labs_id"
                        >
                    </div>
                </div>

                <!-- Dairygold -->
                <div class="mt-4">
                    <h3 class="text-lg font-bold">Dairygold</h3>

                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="dairygold_id">
                            Account ID:
                        </label>

                        <input
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="dairygold_id" type="text" v-model="form.dairygold_id"
                        >
                    </div>
                </div>

                <!-- Southern Scientific -->
                <div class="mt-4">
                    <h3 class="text-lg font-bold">Southern Scientific</h3>

                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="southern_scientific_id">
                            Account ID:
                        </label>

                        <input
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="southern_scientific_id" type="text" v-model="form.southern_scientific_id"
                        >
                    </div>
                </div>

                <!-- IAS -->
                <div class="mt-4">
                    <h3 class="text-lg font-bold">IAS</h3>

                    <div class="flex">
                        <label class="w-28 mt-2.5 text-sm font-medium text-gray-700" for="ias_id">
                            Account ID:
                        </label>

                        <input
                            class="w-40 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="ias_id" type="text" v-model="form.ias_id"
                        >
                    </div>
                </div>

                <div class="mt-8 flex justify-between">
                    <div>
                        <button
                            class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            v-on:click="edit = false"
                        >
                            Cancel
                        </button>
                    </div>

                    <div>
                        <button type="submit"
                            class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500  disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                            v-on:click="update"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import Multiselect from '@vueform/multiselect';
import axios from 'axios';

export default {
    components: {
        Multiselect
    },
    props: {
        organisation: Object,
        labs: Object,
        tests: Object,
    },

    setup() {
        const form = useForm({
            default_lab: '',
            fba_labs_id: '',
            dairygold_id: '',
            southern_scientific_id: '',
            ias_id: '',
            tests: [],
            default_test: ''
        })

        return { form }
    },

    data() {
        return {
            edit: false,
            allowTests:{},
        };
    },

    created() {
        this.form.default_lab = this.organisation.default_lab;
        this.form.fba_labs_id = this.organisation.fba_labs_id;
        this.form.dairygold_id = this.organisation.dairygold_id;
        this.form.southern_scientific_id = this.organisation.southern_scientific_id;
        this.form.ias_id = this.organisation.ias_id;
        this.form.tests = this.organisation.available_test_ids
        this.form.default_test = this.organisation?.default_test?.id
        this.updateAllowTest();

    },

    methods: {
        updateAllowTest() {
            this.allowTests = {};
            this.form.tests.forEach((test) => {
  this.allowTests[test] = this.tests[test];
});

        },
        update() {
            this.form.put(route('app.organisation.labs', this.organisation.id), {
                onSuccess: () => { return window.location = route('app.organisation.index', this.organisation.hashid); }
            })
        },
    }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>